import { SpaceConfig } from "./spaceConfig";

const spacesBase: Partial<SpaceConfig> = {
    reportProblemConfig: {
        titlePlaceholder: "Please add the title here (required)",
        descriptionPlaceholder: "Describe the problem in full, including clear steps to reproduce the issue. \n\nYour initial post will be public; attachments and logs will be available only to Microsoft. After posting, any additional confidential information can be added as a private comment, visible only to Microsoft.",
        showRegressionOptions: true,
        showSeverityOptions: true,
    },
    reportSuggestionConfig: {
        titlePlaceholder: "Please add the title here (required)",
        descriptionPlaceholder: "To help us prioritize what to work on first, please include only one feature request per suggestion.",
        showRegressionOptions: true,
    }
};

/** Used to specify slug is current unknown and will come from server config
 * Used when populating hardcoded space info to workaround a limitation in TypeScript's type system.
 */
export const UnknownSlugWorkaround: string = "unknown";

export default spacesBase;
